module.exports = __webpack_public_path__ + "static/media/grid-metro-15.ac78f581.jpg";